import EmpreendaService from '@/services/EmpreendaService';

export const empreenda = {
    namespaced: true,
    actions: {
        licenciamentosPorSubConsolidado ({ dispatch }) {
            return EmpreendaService.licenciamentosPorSubConsolidado()
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        empresasPorSubConsolidado ({ dispatch }) {
          return EmpreendaService.empresasPorSubConsolidado()
              .then(
                  response => {
                      return response;
                  },
                  error => {
                      console.error(error);
                  }
              );
      },
        returnAtividades ({ dispatch }) {
            return EmpreendaService.returnAtividades()
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        licenciamentosPorSub ({ dispatch }, {dataInicio, dataFim, agrupamento}) {
            return EmpreendaService.licenciamentosPorSub({dataInicio, dataFim, agrupamento})
              .then(
                response => {
                  return response;
                },
                error => {
                  console.error(error);
                }
              );
        },
        licenciamentosPorSubFechado ({ dispatch }, {intervalo}) {
            return EmpreendaService.licenciamentosPorSubFechado({intervalo})
              .then(
                response => {
                  return response;
                },
                error => {
                  console.error(error);
                }
              );
        },
        TMAPorAno ({ dispatch }) {
          return EmpreendaService.TMAPorAno()
              .then(
                  response => {
                      return response;
                  },
                  error => {
                      console.error(error);
                  }
              );
        },
        viabilidadePorSubPorPeriodoFechado ({ dispatch }, {intervalo, agrupamento}) {
          return EmpreendaService.analiseViabilidadePorSubPorPeriodoFechado({intervalo, agrupamento})
            .then(
              response => {
                return response;
              },
              error => {
                console.error(error);
              }
            );
        },
        viabilidadePorSubPorIntervalo ({ dispatch }, {dataInicio, dataFim, agrupamento}) {
          return EmpreendaService.analiseViabilidadePorSubPorIntervalo({dataInicio, dataFim, agrupamento})
            .then(
              response => {
                return response;
              },
              error => {
                console.error(error);
              }
            );
        },
        viabilidadeAberturaSolicitacaoPorIntervalo ({ dispatch }, {dataInicio, dataFim, agrupamento}) {
          return EmpreendaService.analiseViabilidadeAberturaSolicitacaoPorIntervalo({dataInicio, dataFim, agrupamento})
            .then(
              response => {
                return response;
              },
              error => {
                console.error(error);
              }
            );
        },
        viabilidadeResultadoPorIntervalo ({ dispatch }, {intervalo, agrupamento}) {
          return EmpreendaService.analiseViabilidadeResultadoPorIntervalo({intervalo, agrupamento})
            .then(
              response => {
                return response;
              },
              error => {
                console.error(error);
              }
            );
        },
        viabilidadeEstabelecimentoPorIntervalo ({ dispatch }, {intervalo}) {
          return EmpreendaService.analiseViabilidadeEstabelecimentoPorIntervalo({intervalo})
            .then(
              response => {
                return response;
              },
              error => {
                console.error(error);
              }
            );
        },
        ccmEmpresasEmpreendaPorIntervalo ({ dispatch }, {intervalo}) {
          return EmpreendaService.ccmEmpresasEmpreendaFacilPorIntervalo({intervalo})
            .then(
              response => {
                return response;
              },
              error => {
                console.error(error);
              }
            );
        },
        ccmEmpresasNoIntervalo ({ dispatch }, {dataInicio, dataFim, filtrarEmpreenda, agrupamento}) {
          return EmpreendaService.ccmEmpresasNoIntervalo({dataInicio, dataFim, filtrarEmpreenda, agrupamento})
            .then(
              response => {
                return response;
              },
              error => {
                console.error(error);
              }
            );
        },
    },
    state: {},
    mutations: {},
};
